module.exports = __webpack_public_path__ + "static/media/download.9221e225.svg";